'use client';
import React, { Suspense } from 'react';
import Price from '@/components/price/Price';
import FinanceMsg from '@/components/FinanceMsg';
import { useSelectedVariant } from '@/components/product/product-context';
import { useCampaign } from '@/app/CampaignContext';
import offsetBlockClass from '@/utils/offsetBlockClass';
import {
  PriceSkeleton,
  FinanceMsgSkeleton
} from '@/components/price/PriceSkeleton';

const PdpPrice = ({ block, position }) => {
  const campaign = useCampaign();
  const { uid, show_financing, show_offset_block_selector, tag_text } =
    block?.pdp_price?.reference[0];

  return (
    <section
      id={`${uid}_${position}`}
      data-name={'pdp_price'}
      className={offsetBlockClass(show_offset_block_selector, 'not-last:mb-8')}
    >
      {tag_text && (
        <div className="mb-2">
          <span className="badge-text-r border-light-green text-light-green items-center rounded-3xl border-1 px-5 py-1">
            {tag_text}
          </span>
        </div>
      )}
      <div className="min-h-7.5">
        <Suspense
          fallback={
            <PriceSkeleton showPriceDetails={!!campaign.pricing_details} />
          }
        >
          <VariantPrice pricingDetailsData={campaign.pricing_details} />
        </Suspense>
      </div>
      {show_financing && (
        <div className="body-s mt-3 min-h-5.25">
          <Suspense fallback={<FinanceMsgSkeleton />}>
            <FinanceMsg />
          </Suspense>
        </div>
      )}
    </section>
  );
};

/**
 * Reads the selected variant, so it needs to be wrapped in a Suspense tag.
 */
const VariantPrice = ({ pricingDetailsData }) => {
  const { variant } = useSelectedVariant();

  return (
    <Price
      price={variant.price}
      compareAtPrice={variant.compareAtPrice}
      priceClassOverride="price-l"
      crossedPriceClassOverride="price-l-crossed text-dawn-grey-60!"
      showSavings={true}
      darkPdp={true}
      pricingDetailsData={pricingDetailsData}
      pricingDetailsClass={
        'text-dawn-grey-30 body-xs text-right pdp-price-details'
      }
      variant={`add-to-cart-${variant.handle}`}
    />
  );
};

export default PdpPrice;
